import GoogleLoginButton from "../../GoogleLoginButton.jsx";
import React, { useState } from "react";

const SwivuHomeLogin = ({ onLoginSuccess }) => {
  const [isChecked] = useState(false);

  const isTermAccepted = !!localStorage.getItem("termsAccepted");
  return (
  <>
    <div className="mt-2 mb-4 flex flex-col justify-center" style={{ minHeight: "45px" }}>
      {/*{!isTermAccepted && (*/}
      {/*  <div className="flex items-center mb-2">*/}
      {/*    <input*/}
      {/*      type="checkbox"*/}
      {/*      id="agreeCheckbox"*/}
      {/*      checked={isChecked}*/}
      {/*      onChange={() => setIsChecked(!isChecked)}*/}
      {/*      className="w-4 h-4 mr-2 cursor-pointer"*/}
      {/*    />*/}
      {/*    <label htmlFor="agreeCheckbox" className="text-sm text-[#212121] dark:text-[#c0c0c0] cursor-pointer">*/}
      {/*      I agree to the Terms and Conditions*/}
      {/*    </label>*/}
      {/*  </div>*/}

      {/*)}*/}

      <GoogleLoginButton onError={console.log} onSuccess={onLoginSuccess} disabled={!isTermAccepted && !isChecked} />
    </div>
  </>
  )
}

export default SwivuHomeLogin;
